import React, { useContext, useState, useCallback, Fragment, useEffect} from "react";
import { UserContext } from "UserContext";
import {
  FormControlLabel,
  Grid,
  RadioGroup,
  Radio,
  makeStyles, FormControl, InputLabel, Select, MenuItem, Typography,
} from "@material-ui/core";
import { fetchReport, saveReportResponse } from "fetchUtils";
import ReportsCard from "./ReportsCard";
import OrganizationReportsPickerCard from "./OrganizationReportsPickerCard";
import LoadingButton from "./LoadingButton";
import {find, map, propEq} from "ramda";
import {KeyboardDatePicker, MuiPickersUtilsProvider} from "@material-ui/pickers";
import DateFnsUtils from "@date-io/date-fns";
import {notBlank} from "./utils";

const isoDate = date => date.toISOString().substr(0, 10);

const getIapSelectReportUrl = props =>
  `${process.env.REACT_APP_REPORTS_BASE_URL}/reports/iap/select`;

const getOrganizationIapSelectReportUrl = props =>
  `${process.env.REACT_APP_REPORTS_BASE_URL}/reports/iap/select?org-id=${props.selectedOrganization}`;

const getIapSubmissionReportUrl = (startDate, endDate) =>
    `${process.env.REACT_APP_REPORTS_BASE_URL}/reports/iap?startDate=${startDate}&endDate=${endDate}`;

const getIapRegionSubmissionReportUrl = (region, startDate, endDate) =>
    `${process.env.REACT_APP_REPORTS_BASE_URL}/reports/iap?region=${region}&startDate=${startDate}&endDate=${endDate}`;

const getIapContentSubmissionReportUrl = (startDate, endDate) =>
    `${process.env.REACT_APP_REPORTS_BASE_URL}/reports/iap/contest?startDate=${startDate}&endDate=${endDate}`;

const getIapContestRegionSubmissionReportUrl = (region, startDate, endDate) =>
    `${process.env.REACT_APP_REPORTS_BASE_URL}/reports/iap/contest?region=${region}&startDate=${startDate}&endDate=${endDate}`;


const minReportDate = new Date("2016-01-01");

const useStyles = makeStyles(theme => ({
  root: {
    background: theme.palette.secondary.light,
    height: "100%",
    overflowX: "hidden",
  },
  card: {
    position: "relative",
    overflow: "hidden",
  },
  typeColumn: {
    paddingLeft: 20,
    paddingRight: 20,
    marginBottom: 25,
  },
  reportDetailsCard: {
    position: "relative",
    // height: 321,
  },
  reportSelect: {
    width: "100%",
  },
  regionSelect: {
    width: "100%",
  },

  exportButton: {
    width: 120,
    height: 40,
    marginBottom: 15,
    float: "right",
    right: 15,
  },
  radioGroup: {
    justifyContent: "space-around",
    marginBottom: 15,
  },

  dateColumn: {
    paddingLeft: 20,
    paddingRight: 20,
  },

  dateSelect: {
    marginTop: 25,
    marginBottom: 25,
  },

  datePicker: {
    minWidth: 130,
    width: "100%",
  },

}));

const reportTypes = [
  { id: "iap-select", name: "IAP Select Titles" },
  { id: "iap-submission", name: "IAP Submission Report" },
  { id: "iap-contest-submission", name: "IAP Contest Submissions" },
];

const initialState = {
  report: reportTypes[0].id,
  showLoading: false,
  selectedOrganization: "",
  inventoryGroup: "all",
  startDate: new Date(),
  endDate: new Date(),
  countries: [],
  selectedCountry: 'US',
  subdivisions: [],
  selectedSubdivision: "ALL"
};

const IapSelectReport = () => {
  const classes = useStyles();
  const { token, user } = useContext(UserContext);
  const [state, setState] = useState(initialState);

  const handleStateChange = name => value => {
    setState(s => ({ ...s, [name]: value }));
  };

  const handleSelectedOrganization = useCallback(value => {
    handleStateChange("selectedOrganization")(value);
  }, []);

  const handleDateChange = name => value => {
    setState(s => ({
      ...s,
      [name]: value,
    }));
  };

  const fetchCountries = () =>
      fetch(`${process.env.REACT_APP_STIP_BASE_URL}/geography/countries`, {
        method: "GET",
        headers: {
          "Content-Type": "application/json",
          Accept: "application/json",
        },
      });

  const fetchSubdivisions = (country) =>
      fetch(`${process.env.REACT_APP_STIP_BASE_URL}/geography/countries/${country}/subdivisions`, {
        method: "GET",
        headers: {
          "Content-Type": "application/json",
          Accept: "application/json",
        },
      });

  useEffect(() => {
    fetchCountries()
        .then(response => response.json())
        .then(countries => {
          handleStateChange("countries")(countries);
          handleStateChange("selectedCountry")("US")
        });
  }, [])

  useEffect(() => {
    if (notBlank(state.selectedCountry)) {
      fetchSubdivisions(state.selectedCountry)
          .then(response => response.json())
          .then(subs => {
            handleStateChange("subdivisions")(subs);
            handleStateChange("selectedSubdivision")("ALL")
          });
    }
  }, [state.selectedCountry]);


  const exportReport = props => {
    handleStateChange("showLoading")(true);

    console.log(state)

    let url = null;
    let filename = null;
    if (state.report === "iap-select") {
      filename = state.inventoryGroup === "organization"
          ? "iap-select-report-org.csv"
          : "iap-select-report-all.csv"
      url = state.inventoryGroup === "organization"
          ? getOrganizationIapSelectReportUrl(props)
          : getIapSelectReportUrl(props);
    } else if (state.report === "iap-submission") {
      filename = state.inventoryGroup === "region"
          ? "iap-submission-report-region.csv"
          : "iap-submission-report-all.csv"
      if (state.inventoryGroup === "region") {
        const region = state.selectedSubdivision === "ALL"
            ? state.selectedCountry
            : find(propEq("code", state.selectedSubdivision), state.subdivisions).name
        url = getIapRegionSubmissionReportUrl(region, isoDate(state.startDate), isoDate(state.endDate));
      } else {
        url = getIapSubmissionReportUrl(isoDate(state.startDate), isoDate(state.endDate));
      }
    } else if (state.report === "iap-contest-submission") {
      filename = state.inventoryGroup === "region"
          ? "iap-contest-report-region.csv"
          : "iap-contest-report-all.csv"
      if (state.inventoryGroup === "region") {
        const region = state.selectedSubdivision === "ALL"
            ? state.selectedCountry
            : find(propEq("code", state.selectedSubdivision), state.subdivisions).name

        url = getIapContestRegionSubmissionReportUrl(region, isoDate(state.startDate), isoDate(state.endDate));
      } else {
        url = getIapContentSubmissionReportUrl(isoDate(state.startDate), isoDate(state.endDate))

      }
    }

    fetchReport(url, props.token)
      .then(response => saveReportResponse(response, filename))
      .catch(error => console.log(error))
      .finally(() => handleStateChange("showLoading")(false));
  };

  return (
      <Fragment>
        <Grid item xs>
          <ReportsCard cardLabel="REPORT" className={classes.reportDetailsCard}>
            <Grid container direction="column" className={classes.typeColumn}>
              <Grid item>
                <FormControl className={classes.reportSelect}>
                  <InputLabel>Report Type</InputLabel>
                  <Select
                      value={state.report}
                      onChange={e => handleStateChange("report")(e.target.value)}
                  >
                    {map(
                        ({ id, name }) => (
                            <MenuItem key={id} value={id}>
                              {name}
                            </MenuItem>
                        ),
                        reportTypes
                    )}
                  </Select>
                </FormControl>
              </Grid>
            </Grid>
          </ReportsCard>
        </Grid>

        {state.report === "iap-select" && (
            <Grid item xs>
              <ReportsCard cardLabel="REPORT FILTERING" className={classes.card}>
                <Grid container direction="column" className={classes.typeColumn}>
                <Grid item>
                  <RadioGroup
                      row
                      className={classes.radioGroup}
                      value={state.inventoryGroup}
                      onChange={e => handleStateChange("inventoryGroup")(e.target.value)}
                  >
                    <FormControlLabel value="all" control={<Radio />} label="All" />
                    <FormControlLabel
                        value="organization"
                        control={<Radio />}
                        label="Organization"
                    />
                  </RadioGroup>
                </Grid>
                {state.inventoryGroup === "all" && (
                    <Grid item align="right">
                      <LoadingButton
                          variant="contained"
                          disableElevation
                          className={classes.exportButton}
                          onClick={() => exportReport({ token, ...state })}
                          // disabled={props.disableExport}
                          showLoading={state.showLoading}
                      >
                        EXPORT
                      </LoadingButton>
                    </Grid>
                )}
                </Grid>
              </ReportsCard>


              {state.inventoryGroup === "organization" && (
                  <OrganizationReportsPickerCard
                      organizations={user.organizations}
                      onOrganizationChange={handleSelectedOrganization}
                  >
                      <LoadingButton
                          variant="contained"
                          disableElevation
                          className={classes.exportButton}
                          onClick={() => exportReport({ token, ...state })}
                          // disabled={props.disableExport}
                          showLoading={state.showLoading}
                      >
                        EXPORT
                      </LoadingButton>
                  </OrganizationReportsPickerCard>

                )}
            </Grid>
        )}

        { (state.report === "iap-submission" || state.report === "iap-contest-submission") && (
            <Grid item xs>
              <ReportsCard cardLabel="REPORT FILTERING" className={classes.card}>
                <Grid container direction="column" className={classes.typeColumn}>
                  <Grid item>
                    <Grid container direction="column" className={classes.dateColumn}>
                      <Grid item>
                        {state.report === "iap-submission" && (
                          <Typography>
                            Please select a date range not exceeding 6 months
                          </Typography>
                        )}
                        {state.report === "iap-contest-submission" && (
                            <Typography>
                              <strong>Note:</strong> Submissions are only accepted between April 1 and May 31 each year. If you run this report outside of that submission window, the export will be blank.
                            </Typography>
                        )}
                      </Grid>
                      <Grid
                          container
                          item
                          direction="row"
                          alignItems="flex-end"
                          spacing={1}
                          className={classes.dateSelect}
                      >
                        <MuiPickersUtilsProvider utils={DateFnsUtils}>
                          <Grid item xs>
                            <KeyboardDatePicker
                                className={classes.datePicker}
                                margin="normal"
                                id="startDate"
                                label="Start Date"
                                format="MM/dd/yyyy"
                                disableFuture={true}
                                minDate={minReportDate}
                                value={state.startDate}
                                onChange={handleDateChange("startDate")}
                                KeyboardButtonProps={{
                                  "aria-label": "start date",
                                }}
                            />
                          </Grid>

                          <Grid item xs>
                            <KeyboardDatePicker
                                className={classes.datePicker}
                                margin="normal"
                                id="endDate"
                                label="End Date"
                                format="MM/dd/yyyy"
                                disableFuture={true}
                                minDate={minReportDate}
                                value={state.endDate}
                                onChange={handleDateChange("endDate")}
                                KeyboardButtonProps={{
                                  "aria-label": "end date",
                                }}
                            />
                          </Grid>
                        </MuiPickersUtilsProvider>
                      </Grid>
                    </Grid>
                  </Grid>

                  <Grid item>
                    <RadioGroup
                        row
                        className={classes.radioGroup}
                        value={state.inventoryGroup}
                        onChange={e => handleStateChange("inventoryGroup")(e.target.value)}
                    >
                      <FormControlLabel value="all" control={<Radio />} label="All" />
                      <FormControlLabel
                          value="region"
                          control={<Radio />}
                          label="Region"
                      />
                    </RadioGroup>
                  </Grid>

                  {state.inventoryGroup === "all" && (
                      <Grid item align="right">
                        <LoadingButton
                            variant="contained"
                            disableElevation
                            className={classes.exportButton}
                            onClick={() => exportReport({ token, ...state })}
                            // disabled={props.disableExport}
                            showLoading={state.showLoading}
                        >
                          EXPORT
                        </LoadingButton>
                      </Grid>
                  )}
                </Grid>
              </ReportsCard>

              {state.inventoryGroup === "region" && (
                  <ReportsCard cardLabel="REGION" className={classes.card}>
                    <Grid container direction="row" className={classes.typeColumn}>
                      <Grid item xs={6}>
                        <FormControl className={classes.regionSelect}>
                          <InputLabel>Country</InputLabel>
                          <Select
                              value={state.selectedCountry}
                              onChange={e => handleStateChange("selectedCountry")(e.target.value)}
                          >
                            {map(
                                ({ code, name }) => (
                                    <MenuItem key={code} value={code}>
                                      {name}
                                    </MenuItem>
                                ),
                                state.countries
                            )}
                          </Select>
                        </FormControl>
                      </Grid>

                      {notBlank(state.selectedCountry) && (
                          <Grid item xs={6}>
                            <FormControl className={classes.regionSelect}>
                              <InputLabel>Region</InputLabel>
                              <Select
                                  value={state.selectedSubdivision}
                                  onChange={e => handleStateChange("selectedSubdivision")(e.target.value)}
                              >
                                <MenuItem key="ALL" value="ALL">
                                  All
                                </MenuItem>

                                {map(
                                    ({ code, name }) => (
                                        <MenuItem key={code} value={code}>
                                          {name}
                                        </MenuItem>
                                    ),
                                    state.subdivisions
                                )}
                              </Select>
                            </FormControl>
                          </Grid>

                      )}
                  </Grid>
                    <Grid item align="right">
                      <LoadingButton
                          variant="contained"
                          disableElevation
                          className={classes.exportButton}
                          onClick={() => exportReport({ token, ...state })}
                          // disabled={props.disableExport}
                          showLoading={state.showLoading}
                      >
                        EXPORT
                      </LoadingButton>
                    </Grid>
                  </ReportsCard>
              )}
            </Grid>
        )}


      </Fragment>
  );
};

export default IapSelectReport;
